(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/utils/create-bet-event-key.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/utils/create-bet-event-key.js');
"use strict";


const createBetEventKey = (productId, drawNumber, eventNumber) => "".concat(productId, "_").concat(drawNumber, "_").concat(eventNumber);
setGlobal('svs.components.sportinfo.matchInfoRedux.utils', {
  createBetEventKey
});

 })(window);